import React from 'react';
import { Box, Heading } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';

const NumbersHeading: React.FC<{ text: string }> = ({ text }) => (
  <Box
    fontSize={{ base: 96, desktop: 96 }}
    color="brandNavy.500"
    fontWeight={700}
    mb={{ base: 0, desktop: 5 }}
    justifyContent="center"
  >
    {text}
  </Box>
);
const NumbersBody: React.FC<{ text: string }> = ({ text }) => (
  <Heading size={500} as="h3" maxW="300px" w="100%">
    {text}
  </Heading>
);

const MeasureStats: React.FC = () => (
  <Box
    p={{ base: 8, desktop: '60px' }}
    maxW={{ base: '100%', desktop: '6xl' }}
    w="100%"
    bgColor="primary.50"
    borderRadius={2}
    justifyContent="center"
    alignItems="flex-start"
    mb={{ base: '32px', tablet: '72px' }}
  >
    <Box
      w="100%"
      flexDir={{ base: 'column', desktop: 'row' }}
      justifyContent="space-between"
      alignItems={{ base: 'center', desktop: 'flex-start' }}
      textAlign="center"
      gap={4}
    >
      <Box d="block">
        <NumbersHeading text="15B" />
        <NumbersBody text="Square feet measured" />
      </Box>
      <Box d="block">
        <NumbersHeading text="189K" />
        <NumbersBody text="Professionals on the platform" />
      </Box>
      <Box d="block" mt={{ base: '18px', tablet: '0px' }}>
        <Box justifyContent="center">
          <Box
            h={{ base: 63, desktop: 144 }}
            alignItems="center"
            mb={{ base: 3, desktop: 5 }}
          >
            <StaticImage
              src="../../assets/images/measure_stars.png"
              alt="4.5/5 stars in the Apple App store"
            />
          </Box>
        </Box>
        <NumbersBody text="Rating in the Apple App Store" />
      </Box>
    </Box>
  </Box>
);

export default MeasureStats;
